import React, { useRef } from "react";
import "../styles/JobstartModal.css";





const JobStartModal = ({ onManual, onAutofill, onClose }) => {
  const fileInputRef = useRef(null);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (event) => {
      const text = event.target.result;

      // ✅ Simple parsing demo — Replace with your actual PDF parsing logic
      const parsedData = {
        jobTitle: text.match(/Title:\s*(.*)/)?.[1] || "",
        location: text.match(/Location:\s*(.*)/)?.[1] || "",
        description:
          text.match(/Description:\s*([\s\S]*?)Requirements:/)?.[1] || "",
        requirements: text.match(/Requirements:\s*([\s\S]*)/)?.[1] || "",
      };

      onAutofill(parsedData);
    };

    reader.readAsText(file);
  };

  const handleAutofillClick = () => {
    fileInputRef.current.click();
  };

  // ❌ Removed invalid block that referenced `handleStartSelection`

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <button className="close-btn" onClick={onClose}>
          ×
        </button>
        <h2 className="modal-title">Start Job Posting</h2>
        <p className="modal-subtitle">
          Choose how you’d like to fill in the job posting details.
        </p>

        <button className="modal-btn autofill-btn" onClick={handleAutofillClick}>
          Autofill with PDF Upload
        </button>
        <input
          type="file"
          ref={fileInputRef}
          accept="application/pdf"
          style={{ display: "none" }}
          onChange={handleFileUpload}
        />

        <button className="modal-btn manual-btn" onClick={onManual}>
          Fill Manually
        </button>
      </div>
    </div>
  );
};

export default JobStartModal;
